import { React, Component, Container } from 'utils';
import { QualificationStore, Creators } from 'model';
import Slider, { Range } from 'rc-slider';

var key = 1;

class RangeContainer extends Component {

	static getStores() {
		return [QualificationStore];
	}

	static calculateState() {
		var state = QualificationStore.getState();
		var experience = state.experience;

		return {
			min: experience.min,
			max: experience.max
		}
	}

	handleRangeChanged = () => {
		var bounds = this.slider.state.bounds;

		var min = bounds[0];
		var max = bounds[1];

		Creators.experienceRangeChanged(min, max);
	}

	render() {
		var { min, max } = this.state;

		var marks = {};

		for(var i=0; i<=10; i++) {
			marks[i] = (i == 10)?'10+':i + '';
		}
		
		key = (key + 1) % 10;

		return <Range key={key} ref={(slider) => { this.slider = slider; }}
					  min={0} max={10} defaultValue={[min, max]} marks={marks}
					  onAfterChange={this.handleRangeChanged} />;
	}
}

const range = Container.create(RangeContainer);
export default range;


// WEBPACK FOOTER //
// ./src/modules/app/filters/ExperienceRange.js